/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useToast } from "../../context/toast-context";
import useAPIHandler from "../../hook/use-api-handler";
import { logger } from "../../utils/logger";
import { LOAN_INITIAL_STATE } from "./loan-constant";

const useLoanService = () => {
    const [loanModal, setLoanModal] = useState(false);
    const handleClickloanModalOpen = () => setLoanModal(true);
    const handleClickloanModalClose = () => setLoanModal(false);
    const [loanInputs, setLoanInputs] = useState(structuredClone(LOAN_INITIAL_STATE))
    const [loanData, setLoanData] = useState([]);
    const [loanUILoading, setLoanUILoading] = useState(false);
    const [errors, setErrors] = useState([])
    const [createFormUpdateLoading, setCreateFormUpdateLoading] = useState(false);
    const [empList, setEmpList] = useState([])
    const [empGrossSalary, setEmpGrossSalary] = useState(null)
    const [loanListData,setLoanListData]=useState([])

      const [rowsPerPage, setRowsPerPage] = useState(25);
      const [currentPage, setCurrentPage] = useState(0);
      const [totalPages, setTotalPages] = useState(0);
      const [searchQuery, setSearchQuery] = useState("")
      const [empLoanDetails,setEmpLoanDetails]=useState({})
    const { fetchData } = useAPIHandler()
    const { showToastMessage } = useToast();
    const resetForm = () => {
        setLoanInputs(structuredClone(LOAN_INITIAL_STATE))
        setErrors([])
    }
    const fetchLoanList=async()=>{
        try {
            const response=await fetchData({
                url:`/loan?limit=${rowsPerPage}&page=${currentPage + 1}&search=${searchQuery}`,
                method:'GET'
            });
            setLoanListData(response?.data?.loans)
            setTotalPages(response?.data?.pagesNumber)

        } catch(error)  {
            logger.log(error)
        }
    }
    const handleCLickAddLoan = () => {
        handleClickloanModalOpen();
        resetForm()
    }
    const fetchAllEmpData = async () => {
        setLoanUILoading(true);
        try {
            const result = await fetchData({
                url: '/employee',
                // url: '/loan?active=true',
                method: 'GET',
            });
            // Transform the data into the format needed for SelectField
            const employeeList = result?.data?.data?.map(emp => ({
                id: emp?.employee_id,
                name: `${emp?.first_name} ${emp?.last_name}`
            })) || [];
            setEmpList(employeeList);
            setLoanUILoading(false);
        } catch {
            setLoanUILoading(false);
        }
    }
    const fetchEmployeeBenifitByID = async (id) => {
        try {
            setLoanUILoading(true)
            const result = await fetchData({
                url: `/employee/employee-benefit/${id}`,
                method: 'GET',
            });
            const extractSalary = result?.data?.grossSalary || {}
            setLoanInputs((prevInfo) => ({
                ...prevInfo,
                gross_salary: extractSalary
            }));
            setLoanUILoading(false)
        } catch {
            setLoanUILoading(false)
        }
    }
    const fetchEmpLoanDetailsByID = async (empID,loanID) => {
        try {
            // setLoanUILoading(true)
            const result = await fetchData({
                url: `/loan/${loanID}/history/${empID}`,
                method: 'GET',
            });
            setEmpLoanDetails(result?.data?.loans)
            // setLoanUILoading(false)
        } catch {
            logger.log("error")
        }
    }
    const handleSubmit = async () => {
        setCreateFormUpdateLoading(true);
        const {
            employee_id,
            loan_amount,
            gross_salary,
            deduction_type,
            tenure,
            monthly_deduction,
            loan_issue_date,
            loan_deduction_date
        } = loanInputs || {}
        try {
            const url = loanInputs?.loan_id ? `/loan/id` : '/loan'
            const payload = {
                url: url,
                method: 'POST',
                data: {
                    employee_id,
                    loan_amount,
                    gross_salary,
                    deduction_type,
                    tenure,
                    monthly_deduction,
                    loan_issue_date,
                    loan_deduction_date
                }
            }
            const response = await fetchData(payload);
            if (response?.status == "success") {
                showToastMessage({ message: "Loan Apply Successfully!" })
                fetchLoanList()
                handleClickloanModalClose()
            }
        } catch (error) {
            if (error?.type === "JoiValidationError") {
                const errorsAll = {};
                error?.errors?.map((item) => {
                    const { field, message } = item;
                    errorsAll[field] = message;
                });

                showToastMessage({
                    message:
                        Object.keys(errorsAll).length > 0
                            ? "Validation Error!"
                            : "Something went wrong!",
                    color: "danger",
                });
                setErrors(errorsAll);
            }

            if (error?.type === "GeneralError") {
                showToastMessage({
                    message: error.message || "An unknown general error occurred.",
                    color: "danger",
                });
            }
            setCreateFormUpdateLoading(false);
        }
    }
    const handleChange = (e, name) => {
        logger.log("e", e)
        let value = e;
        if (e & e.target) {
            value = e.target.value;
            name = e.target.name
        }
        if (name === "employee_id") {
            fetchEmployeeBenifitByID(value)
        }
        setLoanInputs((prevInfo) => {
            const updatedInputs = {
                ...prevInfo,
                [name]: value
            };
            if (loanInputs.deduction_type === "fixed") {
                if (name === "tenure" || name === "loan_amount") {
                    const loanAmount = name === "loan_amount" ? value : updatedInputs.loan_amount;
                    const tenure = name === "tenure" ? value : updatedInputs.tenure;
                    if (loanAmount && tenure) {
                        updatedInputs.monthly_deduction = (loanAmount / tenure).toFixed(2)
                    }
                }
            }
            else if (loanInputs.deduction_type === "flexible") {
                if (name === "monthly_deduction" || name === "loan_amount") {
                    const loanAmount = name === "loan_amount" ? value : updatedInputs.loan_amount;
                    const monthlyDeduction = name === "monthly_deduction" ? value : updatedInputs.tenure;
                    if (loanAmount && monthlyDeduction) {
                        updatedInputs.tenure = Math.round(loanAmount / monthlyDeduction)
                    }
                }
            }

            return updatedInputs
        });
        // ({
        //     ...prevInfo,
        //     [name]: value
        // }))
    }
    const handleNextPage = () => {
        setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages - 1));
    };

    const handlePreviousPage = () => {
        setCurrentPage((prevPage) => Math.max(prevPage - 1, 0));
    };

    const handleRowsPerPageChange = (value) => {
        setRowsPerPage(Number(value.target.value));
        setCurrentPage(0);
    };
    useEffect(() => {
        fetchAllEmpData();
    }, [])
    useEffect(() => {
        fetchLoanList();
    }, [rowsPerPage, currentPage, searchQuery])
    logger.log("empGrossSalary", empGrossSalary)
    return {
        fetchAllEmpData,
        empList,
        loanInputs,
        handleChange,
        loanModal,
        handleClickloanModalOpen,
        handleClickloanModalClose,
        handleCLickAddLoan,
        handleSubmit,
        loanListData,
        fetchLoanList,
        rowsPerPage,
        currentPage,
        totalPages,
        handleNextPage,
        handlePreviousPage,
        handleRowsPerPageChange,
        searchQuery,
        setSearchQuery,
        fetchEmpLoanDetailsByID,
        empLoanDetails
    }
}

export default useLoanService